import { atom } from "recoil";

export const LoaiDoanhNghiepState = atom({
  key: "LoaiDoanhNghiepState",
  default: "ALL",
});
